import styles from './Chip.module.css';

/** Toggleable filter pill. Uses aria-pressed so state is announced, not just colored. */
export function Chip({ active = false, children, ...rest }) {
  return (
    <button
      type="button"
      aria-pressed={active}
      className={`${styles.chip} ${active ? styles.active : ''}`}
      {...rest}
    >
      {children}
    </button>
  );
}
